import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BidderDetail } from '../../modules/auction/types';

export const bidApi = createApi({
    reducerPath: 'bidApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_URL + "/bid",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("accessToken");
            if (token) {
                headers.set('authorization', `Bearer ${token}`)
            }
            return headers;
        }
    }),
    endpoints: (builder) => ({
        refuseBid: builder.mutation<BidderDetail, number>({
            query: (id) => ({
                url: `refuse`,
                method: 'PUT',
                body: {
                    bidderId: id,
                    note: ""
                }
            }),
            transformResponse: (response: { body: BidderDetail }, meta, arg) => {
                return response.body;
            }
        })
    })
})
export default bidApi;

export const { useRefuseBidMutation } = bidApi;
